export default "__VITE_ASSET__BkxKgPKE__"